/**
 * @generated SignedSource<<dcda23727ddf59803f14535c036c8dcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bidModalTrackingHelpers_item$data = {
  readonly serviceId: string | null;
  readonly relevantAuctionSolution: {
    readonly minNextBidAmount: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "bidModalTrackingHelpers_item";
};
export type bidModalTrackingHelpers_item$key = {
  readonly " $data"?: bidModalTrackingHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"bidModalTrackingHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "bidModalTrackingHelpers_item"
};

(node as any).hash = "ed2dc3a6e0f320d48cf29c3a0d257a4e";

export default node;
